function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.011c0-.42.074-.809.223-1.168.164-.375.38-.697.647-.967.268-.27.58-.479.937-.629A2.885 2.885 0 012.989 0c.416 0 .81.082 1.182.247.372.15.691.36.96.63.267.27.475.591.624.966.163.36.245.749.245 1.168 0 .405-.082.794-.245 1.169-.149.36-.357.674-.625.944-.268.27-.587.486-.959.651-.372.15-.766.225-1.182.225-.417 0-.81-.075-1.182-.225a3.193 3.193 0 01-.937-.651 3.218 3.218 0 01-.647-.944A3.139 3.139 0 010 3.01z",
  fill: "#FF757B"
});

function SvgSelectedBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSelectedBullet;